export default __webpack_public_path__ + "static/media/Thumb_Facial_Hair_02.931881af.png";